var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, Transition as _Transition, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "file_upload d-flex flex-column" };
var _hoisted_2 = { class: "fileupload_box_group d-flex flex-column" };
var _hoisted_3 = { class: "group group_1 d-flex flex-column" };
var _hoisted_4 = { class: "group group_1 d-flex flex-column" };
var _hoisted_5 = { class: "check_box_group" };
var _hoisted_6 = { class: "check_all d-flex align-items-center justify-content-between" };
var _hoisted_7 = ["disabled"];
var _hoisted_8 = {
    for: "check_all",
    class: "d-flex align-items-center"
};
var _hoisted_9 = { class: "check_list flex-column" };
var _hoisted_10 = ["disabled", "id", "onUpdate:modelValue"];
var _hoisted_11 = ["for"];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["onClick"];
var _hoisted_14 = { class: "fixed_btn_group button_group d-flex align-items-center justify-content-center" };
var _hoisted_15 = ["disabled"];
var _hoisted_16 = ["disabled"];
import { ref, onMounted, watch, reactive, computed } from 'vue';
import ApiService from '@/ts/core/services/ApiService';
import Swal from "sweetalert2";
import { createEmptyApplication, UserPartnershipApplication } from '@/ts/UserPartnershipApplication';
import { startSpinner } from '@/ts/modules/startSpinner';
import { UserPartnershipApplicationStatus } from "@/ts/enums/UserPartnershipApplicationStatus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MobileTaxRefund',
    props: {
        mgmtCode: {
            required: true,
            type: String
        },
        introUrl: {
            required: true,
            type: String,
        },
        status: {
            required: true,
            type: String,
        }
    },
    setup: function (__props) {
        var _this = this;
        var locales = ref({});
        var application = reactive(UserPartnershipApplication.from(createEmptyApplication()));
        var props = __props;
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadLocale()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, loadApplication()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        var loadLocale = function () { return __awaiter(_this, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ApiService.get("".concat(process.env.MIX_API_HOST, "/trans/service"))];
                    case 1:
                        data = (_a.sent()).data;
                        if (data) {
                            locales.value = data.data;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error loading locales:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var uploadUrl = "/user/partnership-application/".concat(props.mgmtCode, "/file");
        var showTerms = ref(true);
        var checkAll = ref(false);
        var checks = ref([false, false, false]);
        var toggleTerms = function () {
            showTerms.value = !showTerms.value;
        };
        var toggleAll = function () {
            checks.value = checks.value.map(function () { return checkAll.value; });
        };
        watch(checks, function (newVal) {
            checkAll.value = newVal.every(Boolean);
        }, { deep: true });
        /**
         * @description 신청 정보 로드
         */
        var loadApplication = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiService.get("".concat(process.env.MIX_API_HOST, "/user/partnership-application/").concat(props.mgmtCode))
                        .then(function (_a) {
                        var data = _a.data;
                        console.log(data);
                        Object.assign(application, UserPartnershipApplication.from(data.data));
                    })];
            });
        }); };
        var requiredmissRef = ref();
        var texrefundSubmitRef = ref();
        var taxrefundCancelRef = ref();
        var requiredtermsRef = ref();
        var terms3Ref = ref();
        var terms4Ref = ref();
        var termsRefs = {
            terms3: terms3Ref,
            terms4: terms4Ref,
        };
        var openModal = function (modalRef) {
            var _a, _b;
            var instance = (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.value) !== null && _a !== void 0 ? _a : modalRef;
            (_b = instance === null || instance === void 0 ? void 0 : instance.showModal) === null || _b === void 0 ? void 0 : _b.call(instance);
        };
        var closeModal = function (modalRef) {
            var _a, _b;
            var instance = (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.value) !== null && _a !== void 0 ? _a : modalRef;
            (_b = instance === null || instance === void 0 ? void 0 : instance.closeModal) === null || _b === void 0 ? void 0 : _b.call(instance);
        };
        /**
         * @description application.file_metas 데이터를 type 별로 그룹핑
         */
        var grouped = computed(function () {
            var result = {};
            for (var _i = 0, _a = application.file_metas; _i < _a.length; _i++) {
                var file = _a[_i];
                var field = file.category;
                if (!result[field])
                    result[field] = [];
                result[field].push(file);
            }
            return result;
        });
        var requiredMissTitle = ref('');
        var missingFieldRef = ref(null);
        /**
         * @description 신청서 제출
         */
        var validateRequiredFields = function () { return __awaiter(_this, void 0, void 0, function () {
            var missingRequiredFields, i, fieldKey, files, firstMissing, fieldIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadApplication()];
                    case 1:
                        _a.sent();
                        missingRequiredFields = [];
                        for (i = 1; i <= 10; i++) {
                            fieldKey = "field_".concat(i);
                            files = grouped.value[fieldKey] || [];
                            if (files.length === 0) {
                                missingRequiredFields.push(fieldKey);
                            }
                        }
                        if (missingRequiredFields.length > 0) {
                            firstMissing = missingRequiredFields[0];
                            fieldIndex = firstMissing.split('_')[1];
                            requiredMissTitle.value = "[".concat(locales.value["partnership_taxrefund_item".concat(fieldIndex)] || "".concat(fieldIndex), "]");
                            missingFieldRef.value = document.getElementById("file_field_".concat(fieldIndex));
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                }
            });
        }); };
        var submitCheck = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, spinnerContainer, spinner, isValid;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = startSpinner(), spinnerContainer = _a.spinnerContainer, spinner = _a.spinner;
                        return [4 /*yield*/, validateRequiredFields()];
                    case 1:
                        isValid = _b.sent();
                        if (!isValid) {
                            openModal(requiredmissRef);
                        }
                        else if (checkAll.value == false) {
                            openModal(requiredtermsRef);
                        }
                        else {
                            openModal(texrefundSubmitRef);
                        }
                        if (spinnerContainer)
                            spinnerContainer.style.display = 'none';
                        spinner.stop();
                        return [2 /*return*/];
                }
            });
        }); };
        var submit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, spinnerContainer, spinner;
            return __generator(this, function (_b) {
                _a = startSpinner(), spinnerContainer = _a.spinnerContainer, spinner = _a.spinner;
                ApiService.put("".concat(process.env.MIX_API_HOST, "/user/partnership-application/").concat(props.mgmtCode, "/submit"), {
                    terms_agreed: checkAll.value ? 'y' : 'n'
                })
                    .then(function () {
                    closeModal(texrefundSubmitRef);
                    window.location.reload();
                })
                    .catch(function (_a) {
                    var response = _a.response;
                    Swal.fire({
                        icon: 'error',
                        text: response.data.message || 'error',
                        confirmButtonText: locales.value.common_confirm || 'ok',
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: "btn btn-primary",
                        }
                    }).then(function () {
                        closeModal(texrefundSubmitRef);
                    });
                })
                    .finally(function () {
                    if (spinnerContainer)
                        spinnerContainer.style.display = 'none';
                    spinner.stop();
                });
                return [2 /*return*/];
            });
        }); };
        /**
         * @description 신청 취소(=신청 데이터 삭제)
         */
        var cancel = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, spinnerContainer, spinner;
            return __generator(this, function (_b) {
                _a = startSpinner(), spinnerContainer = _a.spinnerContainer, spinner = _a.spinner;
                return [2 /*return*/, ApiService.delete("".concat(process.env.MIX_API_HOST, "/user/partnership-application/").concat(props.mgmtCode))
                        .then(function (_a) {
                        var data = _a.data;
                        // 데이터 삭제 성공
                        window.location.href = props.introUrl;
                    })
                        .catch(function (_a) {
                        var response = _a.response;
                        Swal.fire({
                            icon: 'error',
                            text: response.data.message || 'error',
                            confirmButtonText: locales.value.common_confirm || 'ok',
                            buttonsStyling: false,
                            customClass: {
                                confirmButton: "btn btn-primary",
                            }
                        }).then(function () {
                            closeModal(texrefundSubmitRef);
                        });
                    })
                        .finally(function () {
                        if (spinnerContainer) {
                            spinnerContainer.style.display = 'none';
                        }
                        spinner.stop();
                    })];
            });
        }); };
        var handleCloseRequiredModal = function () {
            var _a;
            closeModal(requiredmissRef);
            console.log('aa', missingFieldRef.value, (_a = missingFieldRef.value) === null || _a === void 0 ? void 0 : _a.scrollIntoView);
            if (missingFieldRef.value && missingFieldRef.value.scrollIntoView) {
                console.log('bb');
                setTimeout(function () {
                    var _a;
                    (_a = missingFieldRef.value) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 100);
            }
        };
        return function (_ctx, _cache) {
            var _component_mobile_file_upload_card = _resolveComponent("mobile-file-upload-card");
            var _component_alert_modal = _resolveComponent("alert-modal");
            var _component_policies_modal = _resolveComponent("policies-modal");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h6", null, _toDisplayString(locales.value.partnership_taxrefund_subtitle1), 1),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_1'],
                                url: uploadUrl,
                                "field-name": "field_1",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item1,
                                manual: "https://www.jobploy.kr/document/DOC0000000102",
                                status: props.status,
                                ref: "file_field_1",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_2'],
                                url: uploadUrl,
                                "field-name": "field_2",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item2,
                                manual: "https://www.jobploy.kr/document/DOC0000000109",
                                download: "https://api.jobploy.kr/service-file/3a6bdba4-ffba-458a-b663-871d1cd5e53f/download",
                                status: props.status,
                                ref: "file_field_2",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_3'],
                                url: uploadUrl,
                                "field-name": "field_3",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item3,
                                manual: "https://www.jobploy.kr/document/DOC0000000113",
                                status: props.status,
                                ref: "file_field_3",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_4'],
                                url: uploadUrl,
                                "field-name": "field_4",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item4,
                                manual: "https://www.jobploy.kr/document/DOC0000000112",
                                status: props.status,
                                ref: "file_field_4",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_5'],
                                url: uploadUrl,
                                "field-name": "field_5",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item5,
                                manual: "https://www.jobploy.kr/document/DOC0000000111",
                                status: props.status,
                                ref: "file_field_5",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_6'],
                                url: uploadUrl,
                                "field-name": "field_6",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item6,
                                manual: "https://www.jobploy.kr/document/DOC0000000104",
                                status: props.status,
                                ref: "file_field_6",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_7'],
                                url: uploadUrl,
                                "field-name": "field_7",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item7,
                                manual: "https://www.jobploy.kr/document/DOC0000000105",
                                status: props.status,
                                download: "https://api.jobploy.kr/service-file/3c6d8f75-0f9e-49f5-8e4f-45fd4535decf/download",
                                ref: "file_field_7",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_8'],
                                url: uploadUrl,
                                "field-name": "field_8",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item8,
                                manual: "https://www.jobploy.kr/document/DOC0000000106",
                                download: "https://api.jobploy.kr/service-file/744a7f17-0147-431f-a998-8e8242f5bdee/download",
                                status: props.status,
                                ref: "file_field_8",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_9'],
                                url: uploadUrl,
                                "field-name": "field_9",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item9,
                                manual: "https://www.jobploy.kr/document/DOC0000000107",
                                download: "https://api.jobploy.kr/service-file/952c69d3-c6ff-4b12-90da-ab87b3a5dab4/download",
                                status: props.status,
                                ref: "file_field_9",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_10'],
                                url: uploadUrl,
                                "field-name": "field_10",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item10,
                                manual: "https://www.jobploy.kr/document/DOC0000000108",
                                download: "https://api.jobploy.kr/service-file/38762442-0a8d-4369-9510-a391cf404d2f/download",
                                status: props.status,
                                ref: "file_field_10",
                                required: true
                            }, null, 8, ["files", "locales", "title", "status"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h6", null, _toDisplayString(locales.value.partnership_taxrefund_subtitle2), 1),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_11'],
                                url: uploadUrl,
                                "field-name": "field_11",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item11,
                                manual: "https://www.jobploy.kr/document/DOC0000000110",
                                status: props.status,
                                ref: "file_field_11",
                                required: false
                            }, null, 8, ["files", "locales", "title", "status"]),
                            _createVNode(_component_mobile_file_upload_card, {
                                files: grouped.value['field_12'],
                                url: uploadUrl,
                                "field-name": "field_12",
                                locales: locales.value,
                                title: locales.value.partnership_taxrefund_item12,
                                manual: "https://www.jobploy.kr/document/DOC0000000110",
                                status: props.status,
                                ref: "file_field_12",
                                required: false
                            }, null, 8, ["files", "locales", "title", "status"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                disabled: props.status !== _unref(UserPartnershipApplicationStatus).PENDING,
                                id: "check_all",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((checkAll).value = $event); }),
                                onChange: toggleAll
                            }, null, 40, _hoisted_7), [
                                [_vModelCheckbox, checkAll.value]
                            ]),
                            _createElementVNode("label", _hoisted_8, _toDisplayString(locales.value.partnership_taxrefund_terms1), 1),
                            _createElementVNode("button", {
                                class: "down",
                                type: "button",
                                onClick: toggleTerms
                            }, [
                                _createElementVNode("i", {
                                    class: _normalizeClass(["bi bi-chevron-down", { rotated: showTerms.value }])
                                }, null, 2)
                            ])
                        ]),
                        _createVNode(_Transition, { name: "slide" }, {
                            default: _withCtx(function () { return [
                                _withDirectives(_createElementVNode("ul", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checks.value, function (checked, index) {
                                        return (_openBlock(), _createElementBlock("li", {
                                            class: "list d-flex align-items-center justify-content-between",
                                            key: index
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                disabled: props.status !== _unref(UserPartnershipApplicationStatus).PENDING,
                                                class: "normal",
                                                id: "check_".concat(index + 1),
                                                "onUpdate:modelValue": function ($event) { return ((checks.value[index]) = $event); }
                                            }, null, 8, _hoisted_10), [
                                                [_vModelCheckbox, checks.value[index]]
                                            ]),
                                            _createElementVNode("label", {
                                                for: "check_".concat(index + 1),
                                                class: "d-flex"
                                            }, [
                                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-check-lg" }, null, -1)),
                                                _createElementVNode("span", {
                                                    innerHTML: locales.value["partnership_taxrefund_terms".concat(index + 2)]
                                                }, null, 8, _hoisted_12)
                                            ], 8, _hoisted_11),
                                            (index > 0)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    onClick: function ($event) { return (openModal(termsRefs["terms".concat(index + 2)])); }
                                                }, _cache[6] || (_cache[6] = [
                                                    _createElementVNode("i", { class: "bi bi-arrow-right-circle" }, null, -1)
                                                ]), 8, _hoisted_13))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ], 512), [
                                    [_vShow, showTerms.value]
                                ])
                            ]; }),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "white_btn",
                            disabled: props.status !== _unref(UserPartnershipApplicationStatus).PENDING,
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (openModal(taxrefundCancelRef.value)); })
                        }, _toDisplayString(locales.value.common_cancelrequest), 9, _hoisted_15),
                        _createElementVNode("button", {
                            type: "button",
                            class: "blue_btn",
                            disabled: props.status !== _unref(UserPartnershipApplicationStatus).PENDING,
                            onClick: submitCheck
                        }, _toDisplayString(locales.value.common_submit), 9, _hoisted_16)
                    ])
                ]),
                _createVNode(_component_alert_modal, {
                    ref_key: "requiredmissRef",
                    ref: requiredmissRef,
                    locales: locales.value,
                    modalText: locales.value.alert_associate_requiredmiss,
                    modalText2: requiredMissTitle.value,
                    onClose: handleCloseRequiredModal
                }, null, 8, ["locales", "modalText", "modalText2"]),
                _createVNode(_component_alert_modal, {
                    ref_key: "requiredtermsRef",
                    ref: requiredtermsRef,
                    locales: locales.value,
                    modalText: locales.value.alert_associate_terms,
                    onClose: _cache[2] || (_cache[2] = function ($event) { return (closeModal(requiredtermsRef.value)); })
                }, null, 8, ["locales", "modalText"]),
                _createVNode(_component_alert_modal, {
                    ref_key: "texrefundSubmitRef",
                    ref: texrefundSubmitRef,
                    locales: locales.value,
                    modalText: locales.value.cfm_associate_texrefund_submit,
                    modalBtnLeft: locales.value.common_cancel,
                    modalBtnRight: locales.value.common_submit,
                    btnColor: "blue",
                    twoBtn: true,
                    onLeftClick: _cache[3] || (_cache[3] = function ($event) { return (closeModal(texrefundSubmitRef.value)); }),
                    onRightClick: submit
                }, null, 8, ["locales", "modalText", "modalBtnLeft", "modalBtnRight"]),
                _createVNode(_component_alert_modal, {
                    ref_key: "taxrefundCancelRef",
                    ref: taxrefundCancelRef,
                    locales: locales.value,
                    modalText: locales.value.cfm_associate_taxrefund_cancelsubmit,
                    modalBtnLeft: locales.value.common_close,
                    modalBtnRight: locales.value.common_cancelrequest,
                    btnColor: "blue",
                    twoBtn: true,
                    onLeftClick: _cache[4] || (_cache[4] = function ($event) { return (closeModal(taxrefundCancelRef.value)); }),
                    onRightClick: cancel
                }, null, 8, ["locales", "modalText", "modalBtnLeft", "modalBtnRight"]),
                _createVNode(_component_policies_modal, {
                    ref_key: "terms3Ref",
                    ref: terms3Ref,
                    locales: locales.value,
                    modalTitle: locales.value.partnership_taxrefund_terms3_title
                }, {
                    default: _withCtx(function () { return _cache[7] || (_cache[7] = [
                        _createElementVNode("div", { class: "d-flex flex-column gap-3.5" }, [
                            _createElementVNode("div", { class: "d-flex flex-column gap-2" }, [
                                _createElementVNode("p", { class: "fw-semibold" }, "외국인 근로자 세금 환급 신청에 관한 개인정보 제공에 대한 동의"),
                                _createElementVNode("p", null, "“잡플로이”(이하 “회사”)는 이용자의 개인정보를 중요시하며, 정보통신망 이용촉진 및 정보보호에 관한 법률 및 “개인정보보호법”을 준수하고 있습니다."),
                                _createElementVNode("p", null, "회사는 세금 환급 신청 관련 개인정보 처리방침을 통하여 이용자께서 제공하시는 개인정보가 어떤 용도와 방식으로 이용되며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.")
                            ]),
                            _createElementVNode("div", { class: "d-flex flex-column gap-3.5" }, [
                                _createElementVNode("div", { class: "d-flex flex-column gap-2" }, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", null, "1. 개인정보의 수집 및 이용목적"),
                                        _createElementVNode("p", null, "잡플로이는 외국인 근로자 세금 환급 신청을 통해 수집한 개인정보를 다음의 목적을 위해 활용합니다.")
                                    ]),
                                    _createElementVNode("ul", { class: "d-flex flex-column gap-2" }, [
                                        _createElementVNode("li", null, "온라인 상담신청 및 접수"),
                                        _createElementVNode("li", null, "세금 환급을 위한 절차 진행")
                                    ])
                                ]),
                                _createElementVNode("div", { class: "d-flex flex-column gap-2" }, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", null, "2. 수집하는 개인정보 항목 및 수집방법"),
                                        _createElementVNode("p", null, "개인정보 수집 항목.")
                                    ]),
                                    _createElementVNode("ul", { class: "d-flex flex-column gap-2" }, [
                                        _createElementVNode("li", null, "제출하는 서류에 포함되는 모든 개인정보가 수집되며, 이 개인정보는 1. 항에 명시되는 목적 의외로 사용되지 않습니다. ")
                                    ])
                                ]),
                                _createElementVNode("div", { class: "d-flex flex-column gap-2" }, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", null, "3. 개인정보 제공"),
                                        _createElementVNode("p", null, "회사는 이용자의 개인정보를 [개인정보 수집 및 이용목적] 에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만 아래의 경우에는 예외로 합니다.")
                                    ]),
                                    _createElementVNode("ul", { class: "d-flex flex-column gap-2" }, [
                                        _createElementVNode("li", null, "이용자들이 사전에 동의한 경우"),
                                        _createElementVNode("li", null, "법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우")
                                    ])
                                ]),
                                _createElementVNode("div", { class: "d-flex flex-column" }, [
                                    _createElementVNode("p", null, "4. 개인정보의 보유 및 이용기간"),
                                    _createElementVNode("p", null, "이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체없이 파기됩니다. 단, 관련법에 의하여 보존할 필요가 있는 경우 관련 법령에서 정한 일정한 기간동안 개인정보를 보호 합니다.")
                                ]),
                                _createElementVNode("div", { class: "d-flex flex-column" }, [
                                    _createElementVNode("p", null, "5. 개인정보 보호 책임자의 성명"),
                                    _createElementVNode("p", null, "성명 : 박지은"),
                                    _createElementVNode("p", null, "소속 : 잡플로이"),
                                    _createElementVNode("p", null, "전화번호 : 02-875-2134"),
                                    _createElementVNode("p", null, "이메일 : pje@whoopersoft.com")
                                ])
                            ]),
                            _createElementVNode("div", null, [
                                _createElementVNode("p", null, "시행일"),
                                _createElementVNode("p", null, "본 개인정보 보호정책은 2025년 5월 19일부터 시행합니다.")
                            ])
                        ], -1)
                    ]); }),
                    _: 1
                }, 8, ["locales", "modalTitle"]),
                _createVNode(_component_policies_modal, {
                    ref_key: "terms4Ref",
                    ref: terms4Ref,
                    locales: locales.value,
                    modalTitle: locales.value.partnership_taxrefund_terms4_title
                }, {
                    default: _withCtx(function () { return _cache[8] || (_cache[8] = [
                        _createElementVNode("div", { class: "d-flex flex-column gap-3.5" }, [
                            _createElementVNode("div", { class: "d-flex flex-column gap-2" }, [
                                _createElementVNode("p", { class: "fw-semibold" }, "외국인 근로자 세금 환급 신청에 관한 개인정보 제3자 제공에 대한 동의 "),
                                _createElementVNode("p", null, "“잡플로이”(이하 “회사”)는 이용자의 개인정보를 중요시하며, 정보통신망 이용촉진 및 정보보호에 관한 법률 및 “개인정보보호법”을 준수하고 있습니다. 회사는 외국인 근로자 세금 환급 신청 이용자로부터 아래와 같이 개인정보를 제3자에게 제공합니다. ")
                            ]),
                            _createElementVNode("div", { class: "d-flex flex-column gap-3.5" }, [
                                _createElementVNode("div", { class: "d-flex flex-column gap-2" }, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", null, "1. 개인정보 제공"),
                                        _createElementVNode("p", null, "회사는 이용자의 개인정보를 [개인정보의 수집 및 이용목적]에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다. ")
                                    ]),
                                    _createElementVNode("ul", { class: "d-flex flex-column gap-2" }, [
                                        _createElementVNode("li", null, "이용자들이 사전에 동의한 경우(이용자가 사전에 동의한 경우란, 서비스 이용 등을 위하여 이용자가 자발적으로 자신의 개인정보를 제3자에게 제공하는 것에 동의하는 것을 의미합니다), 이러한 경우에도, 회사는 이용자에게 (1) 개인정보를 제공받는 자, (2) 그의 이용목적, (3) 제공되는 개인정보의 항목, (4) 개인정보의 보유 및 이용기간을 사전에 고지하고 이에 대해 명시적/개별적으로 동의를 얻습니다. 이와 같은 모든 과정에 있어서 회사는 이용자의 의사에 반하여 추가적인 정보를 수집하거나, 동의의 범위를 벗어난 정보를 제3자와 공유하지 않습니다. "),
                                        _createElementVNode("li", null, "법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우"),
                                        _createElementVNode("li", null, "개인 맞춤형 광고 서비스를 제공하기 위해 특정 개인을 식별할 수 없는 형태로 제휴사에 제공하는 경우 회사의 서비스 이행을 위하여 개인정보를 제3자에게 제공하고 있는 경우는 다음과 같습니다. ")
                                    ]),
                                    _createElementVNode("div", { class: "d-flex flex-column gap-2" }, [
                                        _createElementVNode("p", null, "1) 이용 목적: 세금 환급 신청 "),
                                        _createElementVNode("p", null, "제공 받는자"),
                                        _createElementVNode("p", null, "가. 세무법인 : 세무법인이음 경기서부지사"),
                                        _createElementVNode("p", null, "나. 세무법인 영업대행사 : 주식회사 에이피솔루션"),
                                        _createElementVNode("ul", { class: "text-graytext" }, [
                                            _createElementVNode("li", null, "제공되는 개인정보 : 세금환급을 위해 업로드되는 서류 내 기재 내용, 회원 이메일, 회원 휴대전화번호, 회원 이름"),
                                            _createElementVNode("li", null, "보유 및 이용기간 : 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. (단, 다른 법령에 특별한 규정이 있을 경우 관련 법령에 따라 보관)")
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", { class: "d-flex flex-column gap-2" }, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", null, "2. 이용자의 개인정보 제3자 제공에 대한 거부 이용자는 회사의 개인정보의 제3자 제공에 대한 동의를 거부할 수 있습니다. 단, 동의를 거부 하는 경우 서비스 결제가 정상적으로 완료 될 수 없음을 알려드립니다. ")
                                    ])
                                ])
                            ]),
                            _createElementVNode("span", null, "※ 개인정보의 처리와 관련된 사항은 회사의 개인정보처리방침에 따릅니다.")
                        ], -1)
                    ]); }),
                    _: 1
                }, 8, ["locales", "modalTitle"])
            ], 64));
        };
    }
});
